import dayjs from "dayjs";

export default function WarDate({date} ) {
	const currentDate = dayjs(date).format("DD MMM, YYYY");

	return (
		<div className="date-genocide-war">
			<h4>{currentDate}</h4>
		</div>
	)
}